import awsLogo from '../assets/aws_marketplace-horizontal.png';
import azureLogo from '../assets/azure-horizontal.png';
import gcpLogo from '../assets/gcp-horizontal.png';
import redhatLogo from '../assets/redhat-horizontal.png';

export const AWS = 'aws';
export const GCP = 'gcp';
export const AZURE = 'azure';
export const REDHAT = 'redhat';

export const CLOUDS = {
  AWS,
  GCP,
  AZURE,
  REDHAT,
};

export const CLOUD_LOGOS = {
  [AWS]: awsLogo,
  [GCP]: gcpLogo,
  [AZURE]: azureLogo,
  [REDHAT]: redhatLogo,
};

export const CLOUD_DISPLAY_LOOKUP = {
  [AWS]: 'AWS',
  [GCP]: 'GCP',
  [AZURE]: 'Azure',
};

export const CONTACT_TACKLE = 'Contact Tackle';
export const CONTACT_SUPPORT = 'mailto:support@tackle.io';

export const VALIDATION_TYPE_EMAIL = 'email';

export const TEST_VENODR_ID = 'DEMOVENDOR1';
export const TEST_PRODUCT_ID = 'DEMOVENDOR1-aws-1603121145';
export const TEST_CUSTOMER_ID = 'some-cust-id';

const exportedObject = {
  CLOUDS,
  CLOUD_LOGOS,
};

export default exportedObject;
